import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Paper, Checkbox, Grid, makeStyles } from "@material-ui/core";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import AdjustIcon from "@material-ui/icons/Adjust";
import { useTranslation } from "react-i18next";
import { get, set } from "@totalsoft/react-state-lens";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "../styles";

const useStyles = makeStyles(clientPageStyle);

function SoleTraderCard({ isSoleTraderFeatureLens, onReset }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const handleChange = useCallback(
    (value) => () => {
      (isSoleTraderFeatureLens |> set)(value);
      onReset();
    },
    [isSoleTraderFeatureLens, onReset]
  );
  return (
    <Paper className={classes.filterStyle}>
      <Grid container>
        <Grid item>
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUncheckedIcon />}
                checkedIcon={<AdjustIcon />}
                checked={!(isSoleTraderFeatureLens |> get)}
                onChange={handleChange(false) |> onCheckBoxChange}
              />
            }
            label={t("Client.CompanyAndPartnership")}
          />
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                color="primary"
                icon={<RadioButtonUncheckedIcon />}
                checkedIcon={<AdjustIcon />}
                checked={isSoleTraderFeatureLens |> get}
                onChange={handleChange(true) |> onCheckBoxChange}
              />
            }
            label={t("Client.SoleTrader")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

SoleTraderCard.propTypes = {
  isSoleTraderFeatureLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default SoleTraderCard;
